module.exports = __webpack_public_path__ + "static/img/icon0.2338e4d3.svg";